import Image from "@components/Image";
import React from "react";
import styles from "./BannerFooter.module.scss";
import cx from "classnames";

export default function BannerFooter({
  className,
  image,
}: {
  image?: { src: string; alt: string };
  className?: string | { [key: string]: string };
}) {
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <Image
        wrapperProps={{ className: cx(styles.image, className) }}
        src={image?.src ?? ""}
        alt={image?.alt ?? ""}
        layout="fill"
        scale={1.18}
      />
    </div>
  );
}
